import { get } from "./customAxios";

export function checkValidFormInput(formElement) {
  let isValid = true;
  for (let i = 0; i <= formElement.length; i++) {
    let ele = formElement[i];
    if (!isValidInput(ele)) {
      isValid = false;
      break;
    }
  }
  return isValid;
}

export function isValidInput(ele) {
  if (!ele || !ele.validity || !ele.validity.valid) {
    return false;
  }
  if (ele.attributes.number && ele.attributes.number.value === "true") {
    if (isNaN(ele.value) || ele.value === "") {
      return false;
    }

    if (ele.attributes.min) {
      if (Number(ele.value) <= ele.attributes.min.value) {
        return false;
      }
    }
  }
  return true;
}

export function validNumber(ele) {
  if (ele.attributes.number) {
    if (isNaN(ele.value)) {
      return false;
    }
  }
  return true;
}

export function getValue(e) {
  if (e.target.type === "checkbox") return e.target.checked;
  else if (e.target.type === "file") {
    var files = e.target.files;
    if (files.length === 1) {
      return files[0];
    } else {
      let f = [];
      for (let i = 0; i <= files.length; i++) {
        let file = files[i];
        f.push(file);
      }
      return f;
    }
  } else {
    let value = e.target.value;
    return value;
  }
}

export function limitDigit(number, limit) {
  if (!number) return number;

  let part = number.toString().split(".");
  if (part.length > 1) {
    if (part[1] && part[1].length > limit) {
      part[1] = part[1].slice(0, limit);
    }

    return part.join(".");
  } else return number;
}

export function toFixed(number = 0, float = 2, noComma, noFixZero) {
  if (isNaN(number) || number === null) return 0;
  let floating = 0;
  //if not fix floating = number of float
  if (noFixZero) {
    let s = number.toString().split(".");
    if (s[1] && s[1].length > float) {
      floating = Number(number).toFixed(float);
    } else {
      floating = Number(number);
    }
  } else floating = Number(number).toFixed(float);

  let parts = floating.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (!Number(parts[1])) parts = parts.splice(0, 1);
  if (noComma) return parts.join(".").replace(/,/g, "");
  else return parts.join(".");
}

export function downloadFile(getURL, axiosOption) {
  let promise = get(getURL, {
    responseType: "blob",
    ...axiosOption,
  });

  promise
    .then((response) => {
      var url = URL.createObjectURL(response.data);
      let fileName = decodeURIComponent(response.headers["file-name"]);
      fileName = fileName.replace(/%20/g, " ");
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.download = fileName;
      a.click();
      a.remove();
    })
    .catch((error) => {
      alert("somthing went wrong!");
    });
  return promise;
}

export function findIndex(array = [], compareFn) {
  var index = -1;
  for (var i = 0; i < array.length; i++) {
    if (compareFn(array[i], i, array)) {
      index = i;
      i = array.length;
    }
  }
  return index;
}

export function getDate(string, splitChar = "/") {
  let s = string.split(splitChar);
  let t = s[0];
  s[0] = s[1];
  s[1] = t;
  return new Date(s.join(splitChar));
}

export function getDateString(string, splitChar) {
  let d = getDate(string, splitChar);
  return window.moment(d).format("MM/DD/YYYY");
}

export function getStatusTos(t) {
  if (!t) return "";
  return t.toLowerCase() === "cancel" ? "Cancelled" : t;
}
